export { dedupeDependencies, DedupedDependencies, getEmptyDedupedDependencies } from './dedupe-dependencies';
